import React, { FC, useContext, createContext, useMemo } from 'react';
import { UAParser } from 'ua-parser-js';

export const UserAgentContext = createContext<string>('');

interface PropTypes {
  userAgentString: string;
}

export const UserAgentProvider: FC<PropTypes> = ({
  children,
  userAgentString,
}) => (
  <UserAgentContext.Provider value={userAgentString}>
    {children}
  </UserAgentContext.Provider>
);

export const useUAParser = (): IUAParser.IResult => {
  const userAgentString = useContext(UserAgentContext);

  return useMemo(() => new UAParser(userAgentString).getResult(), [
    userAgentString,
  ]);
};

export default useUAParser;
